import { render, staticRenderFns } from "./tableeditdel.vue?vue&type=template&id=72ed3ce0"
import script from "./tableeditdel.vue?vue&type=script&lang=js"
export * from "./tableeditdel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports